(function () {
  'use strict';

  function initContact(section) {
    if (!section || section.dataset.wantedContactReady === 'true') return;
    section.dataset.wantedContactReady = 'true';

    var message = section.querySelector('[data-nvc-message]');
    var counter = section.querySelector('[data-nvc-count]');
    var form = section.querySelector('form');
    var submit = section.querySelector('[data-nvc-submit]');
    var submitText = section.querySelector('[data-nvc-submit-text]');
    var success = section.querySelector('[data-nvc-success]');
    var revealItems = Array.from(section.querySelectorAll('[data-nvc-reveal]'));

    function updateCount() {
      if (!message || !counter) return;
      var max = Number(message.getAttribute('maxlength')) || 600;
      counter.textContent = message.value.length + ' / ' + max;
    }

    if (message) {
      updateCount();
      message.addEventListener('input', updateCount);
    }

    if (form && submit) {
      form.addEventListener('submit', function () {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        if (submitText) submitText.textContent = submit.getAttribute('data-sending-label') || 'SENDING...';
      });
    }

    if (success) {
      window.setTimeout(function () {
        try { success.focus({ preventScroll: true }); } catch (error) { success.focus(); }
      }, 80);
    }

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });

      revealItems.forEach(function (item) { observer.observe(item); });
    } else {
      revealItems.forEach(function (item) { item.classList.add('is-visible'); });
    }
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-wanted-contact]').forEach(initContact);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
